module.exports = __webpack_public_path__ + "img/boots_of_elves.e04f5dee.png";